// extracted by mini-css-extract-plugin
export var closeButton = "_fu-1";
export var closeX = "_fu-3";
export var container = "_fu-0";
export var image = "_fu-2";